import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useMemo, useRef } from 'react';
import { useInstanceId } from 'shared/src/hooks';
import type { GoodsDetailTab } from '../types/GoodsDetailTab';
import { useGoodsSnoKey } from '../hooks/useGoodsSnoKey';

const tabAtom = atom<Record<string, GoodsDetailTab>>({});

export const useTab = () => {
  const key = useGoodsSnoKey('tab');

  const derivedAtom = useMemo(
    () => atom(get => get(tabAtom)[key] ?? 'INFORMATION'),
    [key],
  );
  return useAtomValue(derivedAtom);
};

export const useSetTab = () => {
  const instanceId = useInstanceId();
  const set = useSetAtom(tabAtom);
  return useCallback(
    (nextTab: GoodsDetailTab) => {
      set(prev => {
        if (prev[instanceId] === nextTab) return prev;
        return { ...prev, [instanceId]: nextTab };
      });
    },
    [instanceId, set],
  );
};

/**
 * tab의 현재 값을 ref로 접근할 수 있는 훅.
 * 콜백 안에서 최신 tab 값을 참조할 때 사용.
 */
export const useTabRef = () => {
  const tab = useTab();
  const tabRef = useRef(tab);
  tabRef.current = tab;
  return tabRef;
};
